import { useReducer } from "react";
import photosActions from "./photosActions";
import photosReducer from "./photosReducer";


export default function usePhotos() {
  const [photos, photosDispatch] = useReducer(photosReducer, {});
  const { fetchList,
    setUploadProgress,
    updatePhotoSource,
    addPhoto,
    renamePhoto,
    deletePhoto  } = photosActions(photosDispatch);

  return {
    response: photos,
    fetchList,
    setUploadProgress,
    updatePhotoSource,
    addPhoto,
    renamePhoto,
    deletePhoto 
  };
}
